import AsyncRequest, {PostDataParameters} from "../../shared/async-request";
import {Alert} from "../../shared/alert";
import {Loading} from "../../shared/loading";
import {IndexedDbHelper} from "../../shared/indexed-db-helper";

class SnippetLoginClass {
	constructor() {
		$(document).on('document.load', async () => await this.init());
	}
	
	async init() {
		this.instance = {
			controls: {
				txtEmail : $("#txtEmail"),
				txtPassword : $("#txtPassword"),
				hdfReturnUrl : $("#hdfReturnUrl"),
				btnLogin : $("#btnLogin"),
			}
		}
		
		this.bindEvents();
	}

	bindEvents() {
		this.instance.controls.btnLogin.on('click', async (e) => {
			e.preventDefault();
			await this.executeLogin();
		})
	}

	async executeLogin() {
		let data = {
			email : this.instance.controls.txtEmail.val(),
			password: this.instance.controls.txtPassword.val()
		};
		await Loading.show();

		if (!data.email || !data.password) {
			await Loading.hide();
			Alert.alert({header: 'Dados Obrigatórios', message: 'Email/Senha não preenchidos'})
			return;
		}
		
		let result = await AsyncRequest.postDataV2(new PostDataParameters({
			url: '/components/account/login',
			data
		}));
		
		if(!result.isSuccess){
			await Loading.hide();
			
			Alert.alert({header: 'Erro ao efetuar login', message: result.message});
			return;
		}

		let returnUrl = this.instance.controls.hdfReturnUrl.val();
		
		await Loading.hide();
		window.location = returnUrl ? returnUrl : '/';		
	}
}


export const SnippetLogin = new SnippetLoginClass()
window.SnippetLogin = SnippetLogin;